import { render, staticRenderFns } from "./GoodsEdit.vue?vue&type=template&id=f32bce70"
import script from "./GoodsEdit.vue?vue&type=script&lang=js"
export * from "./GoodsEdit.vue?vue&type=script&lang=js"
import style0 from "./GoodsEdit.vue?vue&type=style&index=0&id=f32bce70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports